import { render, staticRenderFns } from "./searchRecordList.vue?vue&type=template&id=6a63679d&"
import script from "./searchRecordList.vue?vue&type=script&lang=js&"
export * from "./searchRecordList.vue?vue&type=script&lang=js&"
import style0 from "./searchRecordList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports